import {TiMeLogger} from 'features/logger';

export const TiMePostsLogger = TiMeLogger.child({
    name: 'posts',
});
